import {initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCcQiw_6X12vmYPIoILFxt6N11zcnHLmIk",
    authDomain: "runtop-webiste.firebaseapp.com",
    projectId: "runtop-webiste",
    storageBucket: "runtop-webiste.firebasestorage.app",
    messagingSenderId: "888242131162",
    appId: "1:888242131162:web:2366a472e0ac85a35b15e3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
